
import React from 'react';
import { Link } from 'react-router-dom';
import { Separator } from '@/components/ui/separator';
import { useLanguage } from '@/contexts/LanguageContext';
import { Menu } from 'lucide-react';
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from '@/components/ui/navigation-menu';
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from '@/components/ui/sheet';

const Header: React.FC = () => {
  const { language } = useLanguage();
  
  const navItems = language === 'ur' ? [
    { label: 'ہوم', path: '/' },
    { label: 'ہمارے بارے میں', path: '/about' },
    { label: 'قانونی رہنما', path: '/legal-guides' },
    { label: 'سوالات', path: '/faq' },
  ] : [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about' },
    { label: 'Legal Guides', path: '/legal-guides' },
    { label: 'FAQ', path: '/faq' },
  ];
  
  return (
    <header className={`adalat-header py-6 px-4 ${language === 'ur' ? 'font-urdu rtl' : 'font-english ltr'}`}>
      <div className="container mx-auto relative z-10">
        {/* Desktop Navigation */}
        <div className="hidden md:flex justify-center mb-6">
          <NavigationMenu>
            <NavigationMenuList>
              {navItems.map((item) => (
                <NavigationMenuItem key={item.path}>
                  <Link to={item.path}>
                    <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                      {item.label}
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
              ))}
            </NavigationMenuList>
          </NavigationMenu>
        </div>

        {/* Mobile Navigation */}
        <div className="md:hidden flex justify-between items-center mb-4">
          <Sheet>
            <SheetTrigger asChild>
              <button className="p-2">
                <Menu className="h-6 w-6" />
              </button>
            </SheetTrigger>
            <SheetContent side={language === 'ur' ? 'right' : 'left'}>
              <nav className="flex flex-col gap-4 mt-8">
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`text-lg font-medium hover:text-primary ${language === 'ur' ? 'text-right' : 'text-left'}`}
                  >
                    {item.label}
                  </Link>
                ))}
              </nav>
            </SheetContent>
          </Sheet>
        </div>

        <div className="text-center">
          <h1 className={`${language === 'ur' ? 'text-urdu-3xl' : 'text-4xl md:text-5xl'} font-bold mb-3 bg-clip-text text-transparent bg-gradient-to-r from-blue-700 to-indigo-600`}>
            {language === 'ur' ? 'عدالت بوٹ' : 'Adalat Bot'}
          </h1>
          <p className={`${language === 'ur' ? 'text-urdu-lg' : 'text-xl'} text-gray-600 mb-4`}>
            {language === 'ur' 
              ? 'اپنا مسئلہ بیان کریں، ہم آپ کے لیے اردو میں مکمل درخواست تیار کریں گے' 
              : 'Describe your issue, we will prepare a complete application for you'}
          </p>
          <Separator className="max-w-md mx-auto bg-gradient-to-r from-blue-200 via-indigo-300 to-blue-200 h-0.5" />
        </div>
      </div>
    </header>
  );
};

export default Header;
